export default __webpack_public_path__ + "static/media/info-meeting.a9bdd94e.jpg";